import {
  SET_CURRENT_COMPANY_BIZMINER_RATIOS,
  SET_CURRENT_COMPANY_DUPONT_RATIOS,
  SET_CURRENT_COMPANY_ALTMAN_Z_SCORE,
} from "./mutations";

const initialState = {
  currentCompanyBizminerRatios: null,
  currentCompanyDupontRatios: null,
  currentCompanyAltmanZScore: null,
};

const financialRatiosReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CURRENT_COMPANY_BIZMINER_RATIOS:
      return { ...state, currentCompanyBizminerRatios: payload }

    case SET_CURRENT_COMPANY_DUPONT_RATIOS:
      return { ...state, currentCompanyDupontRatios: payload }
    
    case SET_CURRENT_COMPANY_ALTMAN_Z_SCORE:
      return { ...state, currentCompanyAltmanZScore: payload }

    default:
      return state;
  }
};

export default financialRatiosReducer;
